/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-named-as-default-member */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import CreatableSelect from 'react-select/lib/Creatable'
import _ from 'lodash'
import { Form } from 'semantic-ui-react'

import firebase from '../../../config/firebase'
import TagActions from '../../../reducers/tagReducer'

class TagsField extends Component {
  state = {
    options: [],
    adding: false,
  }

  componentDidMount() {
    const { fetchTags, loaded, tags } = this.props

    if (!loaded) {
      fetchTags()
    }

    if (_.size(tags) > 0) {
      this.setTagOptions(tags)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { tags } = this.props

    if (nextProps.tags !== tags) {
      this.setTagOptions(nextProps.tags)
    }
  }

  setTagOptions = options => {
    this.setState({ options })
  }

  onChange = selectedOptions => {
    const { onChange } = this.props

    const result = _.map(selectedOptions, 'value')

    onChange(result)
  }

  onCreateOption = value => {
    const self = this
    const { key } = firebase
      .database()
      .ref()
      .child('tags')
      .push()

    const updates = { [`tags/${key}`]: value }

    this.setState({ adding: true })

    firebase
      .database()
      .ref()
      .update(updates)
      .then(() =>
        self.setState({ adding: false }, () => {
          self.onCreateNewOptionSuccess(key, value)
        })
      )
  }

  onCreateNewOptionSuccess = (newKey, newValue) => {
    const { value, setTags, tags, onChange } = this.props
    const { options: existingOptions } = this.state
    const result = [...value, newKey]

    const newTags = { ...tags, [newKey]: newValue }
    const newOptions = { ...existingOptions, [newKey]: newValue }

    this.setState({ options: newOptions }, () => {
      setTags(newTags)
      onChange(result)
    })
  }

  serializeOptions = options =>
    _.map(options, (value, key) => ({
      value: key,
      label: value,
    }))

  serializeValues = value => {
    const { options } = this.state

    const selectedTags = [].concat(value)
    const selectedOptions = _.pickBy(options, (val, key) => _.includes(selectedTags, key))

    return this.serializeOptions(selectedOptions)
  }

  render() {
    const { adding, options } = this.state
    const { value, loading } = this.props

    return (
      <Form.Field>
        <label>Tags</label>
        <CreatableSelect
          isMulti
          isDisabled={loading || adding}
          isLoading={loading || adding}
          value={this.serializeValues(value)}
          options={this.serializeOptions(options)}
          onChange={this.onChange}
          onCreateOption={this.onCreateOption}
        />
      </Form.Field>
    )
  }
}

const mapStateToProps = ({ tags }) => ({
  tags: tags.data,
  loading: tags.loading,
  loaded: tags.loaded,
})

const mapDispatchToProps = dispatch => ({
  fetchTags: () => dispatch(TagActions.fetchTagsRequest()),
  setTags: tags => dispatch(TagActions.setTags(tags)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TagsField)



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/tagsField.js